import type { ReactNode } from 'react';

export const symbol_pen_size_5: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M210-320.12Q210-366 242-398l320-320q32.15-32 78.07-32Q686-750 718-717.88q32 32.12 32 78T718-562L398-242q-32.15 32-78.07 32Q274-210 242-242.12q-32-32.12-32-78Z"
		/>
	</svg>
);
